import { createModule } from '../../createModule';
export const createPricingInterfaceAPI = createModule(({ http }) => {
    return {
        runRisk: async (body) => {
            const res = await http.post('/v2/pricing-interface/risk', { body: body });
            return res;
        },
        runScenario: async (body) => {
            const res = await http.post('/v2/pricing-interface/scenario', { body: body });
            return res;
        },
        runNPV: async (body) => {
            const res = await http.post('/v2/pricing-interface/npv', { body: body });
            return res;
        },
        getState: async () => {
            const res = await http.get('/v2/pricing-interface/instance-queue');
            return res;
        },
        stressTests: {
            getResults: async (params) => {
                const res = await http.get('/v2/pricing-interface/stresstest/results', { params });
                return res;
            },
        },
    };
});
